import animationManager, { makeSequence } from '../../../../shared/services/animation-manager';

export const registerContextualDrawerOpening = ({ onStartOpening, onFinishOpening }: { onStartOpening: () => void; onFinishOpening: () => void }): void => {
  animationManager.register(
    'openContextualDrawer',
    makeSequence([
      [
        {
          onStart: onStartOpening,
          elementSelector: '.phn-nd-contextual-drawer',
          animation: {
            className: 'slide-in-from-left',
            cleanUpAfterAnimation: element => {
              element.style.left = '0px';
            },
          },
        },
        {
          onEnd: onFinishOpening,
          elementSelector: '.contextual-drawer-backdrop',
          animation: {
            className: 'fade-in-animation',
            cleanUpAfterAnimation: element => {
              element.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
              element.style.opacity = '1';
            },
          },
        },
      ],
    ]),
  );
};

export const registerContextualDrawerClosing = ({ onStartClosing }: { onStartClosing: () => void }): void => {
  animationManager.register(
    'closeContextualDrawer',
    makeSequence([
      [
        {
          onStart: onStartClosing,
          elementSelector: '.phn-nd-contextual-drawer',
          animation: {
            className: 'slide-out-to-left',
            cleanUpBeforeAnimation: element => {
              element.style.left = '';
            },
          },
        },
        {
          elementSelector: '.contextual-drawer-backdrop',
          animation: {
            className: 'fade-out-animation',
            cleanUpBeforeAnimation: element => {
              element.style.backgroundColor = '';
              element.style.opacity = '';
            },
          },
        },
      ],
    ]),
  );
};
